import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'relativeTime',
    standalone: true,
})
export class RelativeTimePipe implements PipeTransform {
    transform(value: string | Date): string {
        if (!value) return '';

        const inputDate = new Date(value);
        const today = new Date();
        const yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 1);
        const dayBeforeYesterday = new Date(today);
        dayBeforeYesterday.setDate(today.getDate() - 2);

        // Reset time to compare only dates
        const inputDateOnly = new Date(inputDate.getFullYear(), inputDate.getMonth(), inputDate.getDate());
        const todayOnly = new Date(today.getFullYear(), today.getMonth(), today.getDate());
        const yesterdayOnly = new Date(yesterday.getFullYear(), yesterday.getMonth(), yesterday.getDate());
        const dayBeforeYesterdayOnly = new Date(
            dayBeforeYesterday.getFullYear(),
            dayBeforeYesterday.getMonth(),
            dayBeforeYesterday.getDate()
        );

        if (inputDateOnly.getTime() === todayOnly.getTime()) {
            // Today - show only time
            return inputDate.toLocaleTimeString('nl-NL', {
                hour: '2-digit',
                minute: '2-digit',
            });
        } else if (inputDateOnly.getTime() === yesterdayOnly.getTime()) {
            // Yesterday
            return 'Gisteren';
        } else if (inputDateOnly.getTime() === dayBeforeYesterdayOnly.getTime()) {
            // Day before yesterday
            return 'Eergisteren';
        } else {
            // Older dates - show date
            return inputDate.toLocaleDateString('nl-NL', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
            });
        }
    }
}
